<style lang="scss"
       module>
@import 'src/brand/brandColors';
@import 'src/brand/typography.variables';
@import 'src/brand/structure.variables';

.fullSolution {
  position: relative;
  font-family: $font-stack-condensed;
  -webkit-font-smoothing: antialiased;
  color: $white;
  background: $blue;
  text-align: center;
  width: 100%;
  cursor: pointer;
  margin-bottom: $desktop-gutter;
  &:nth-of-type(even) {
    background: $orange;
  }
}

.solution {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-end;
  align-items: center;
  min-height: 13.6rem;
  padding: 2 * $mobile-spacing $mobile-spacing $mobile-spacing $mobile-spacing;
}

.blueSolution {
  composes: fullSolution;
}

.orangeSolution {
  composes: fullSolution;
}

.headline {
  font-size: 2.4rem;
  line-height: 2.4rem;
  font-weight: 700;
  text-transform: uppercase;
}

.subheadline {
  font-size: 1.4rem;
  line-height: 1.8rem;
  font-weight: 700;
}

.icon {
  width: 2rem;
  min-height: 2rem;
  margin-top: 2 * $mobile-spacing;
  margin-bottom: $mobile-spacing;
}

.information {
  font-size: 1.4rem;
  line-height: 1.8rem;
  margin: 2 * $mobile-spacing;
}

.stat {
  background: $gray;
  padding: $mobile-spacing;
  font-size: 1.8rem;
  line-height: 2.2rem;
}

.openDesktop {
  position: absolute;
  top: 0;
  left: 0;
}

@media screen and (min-width: $mobile) {
  .fullSolution {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    min-height: 17.5rem;
    min-width: 24.5rem;
    flex: 1;
    margin-right: $desktop-gutter;
    &:nth-of-type(even) {
      background: $blue;
      margin-right: 0;
    }
  }
  .blueSolution {
    background: $blue;
  }
  .orangeSolution {
    background: $orange !important;
  }

  .headline {
    font-size: 2.8rem;
  }

  .subheadline {
    font-size: 1.8rem;
    line-height: 1.8rem;
  }

  .information {
    font-size: 1.8rem;
    line-height: 2.2rem;
    margin: 2 * $desktop-spacing;
  }
}
</style>
<template>
  <div
    :class="[isBlue ? $style.blueSolution : $style.orangeSolution]"
    @click="toggleOpen">
    <div
      :class="$style.solution"
      @click="getLocation">
      <div :class="$style.headline">{{ head }}:</div>
      <div :class="$style.subheadline">{{ subhead }}</div>
      <img
        v-if="!isOpen"
        :class="$style.icon"
        src="plus.svg"
        alt=""> <img
          v-else
          :class="$style.icon"
          src="minus.svg"
          alt="">
    </div>
    <div
      v-if="isOpenMobile"
      :class="$style.information">
      {{ content }}
    </div>
    <div
      v-if="isOpenMobile"
      :class="$style.stat">{{ stat }}
    </div>
  </div>
</template>


<script>
/* Vue Components */
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */

export default {
  name: 'Solution',
  components: {},
  props: {
    openId: {
      type: Number,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    isBlue: {
      type: Boolean,
      default: true,
    },
    head: {
      type: String,
      required: true,
    },
    subhead: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    stat: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      isMobileView: false,
      isOpenMobile: false,
      isOpenDesktop: false,
      modalTop: '',
      modalLeft: '',
    };
  },
  watch: {
    openId() {
      if (this.openId !== this.id) {
        this.isOpen = false;
        console.log(this.isOpen);
      }
    },
    isOpen() {
      this.isOpenMobile = this.isOpen === true && this.isMobileView;
      this.isOpenDesktop = this.isOpen === true && !this.isMobileView;
    },
  },
  created() {
    this.isMobileView = window.innerWidth <= 639;
    window.addEventListener('resize', () => {
      this.isMobileView = window.innerWidth <= 639;
    });
  },
  methods: {
    getLocation() {
      this.$emit(
        'openModule',
        this.$el.offsetTop,
        this.$el.offsetLeft,
        this.head,
        this.subhead,
        this.content,
        this.stat,
        this.isBlue,
        this.id,
        this.isMobileView,
      );
    },
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
